import React, { useState } from 'react';
import ProjectInformationModal from '../ProjectInformationModal';

export default function ProjectDetail({project}) {
  const [modalOpen, setModalOpen] = useState(false);

    const statusColors = {
        inprogress: "#FFA500",  // Orange
        planning: "#3498DB",    // Blue
        completed: "#2ECC71",   // Green
        cancelled: "#E74C3C",    // Red
    };

    // Pick the right color or fallback
    const statusColor = statusColors[project?.status?.toLowerCase()] || "#6B7280"; // default gray


  const getProjectImage = (project) => {
    if (project?.image) return project.image;
    if (Array.isArray(project?.images) && project.images.length > 0) {
      return project.images[0];
    }
    return null;
  };

  // Handle modal open
  const handleOpenModal = () => {
    setModalOpen(true);
  };

  // Handle modal close
  const handleCloseModal = () => {
    setModalOpen(false);
  };


  return (
    <section className="mb-16">
      <h2 className="text-3xl font-bold mb-8 text-[#0258DA]">Featured Project</h2>

      <div className="bg-white rounded-lg shadow-lg overflow-hidden">
        <div className="grid grid-cols-1 lg:grid-cols-2">
          <div className="h-80 lg:h-auto relative overflow-hidden">
            {getProjectImage(project) ? (
              <>
                <img
                  src={getProjectImage(project)}
                  alt={project?.name}
                  className="w-full h-full object-cover"
                />
                {/* overlay for readability */}
                <div className="absolute inset-0 bg-black/20"></div>
              </>
            ) : (
              <div className="w-full h-full bg-blue-100 relative">
                <div className="absolute inset-0 flex items-center justify-center text-[#0258DA] opacity-20">
                  <svg
                    className="w-64 h-64"
                    fill="currentColor"
                    viewBox="0 0 200 200"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="M30,15 L50,15 L50,45 L30,45 Z M10,15 L25,15 L25,45 L10,45 Z M55,15 L70,15 L70,45 L55,45 Z M75,15 L90,15 L90,45 L75,45 Z"></path>
                  </svg>
                </div>
              </div>
            )}

            <span
              className="absolute top-4 left-4 text-white text-xs font-bold px-3 py-1 rounded-full z-10"
              style={{ backgroundColor: statusColor }}
            >
    {project?.status}
  </span>
          </div>

          <div className="p-5 md:p-8">
            <h3 className="text-2xl font-bold mb-4 text-[#0258DA]">
              {project?.name}
            </h3>
            <p className="text-[#465362] mb-6">
              {project?.desc}
            </p>

            <div className="grid grid-cols-2 gap-6 mb-6">
              <div>
                <h4 className="text-sm text-[#465362] mb-1">Client</h4>
                <p className="font-medium">{project?.client}</p>
              </div>
              <div>
                <h4 className="text-sm text-[#465362] mb-1">Timeline</h4>
                <p className="font-medium">{project?.timeline}</p>
              </div>
              <div>
                <h4 className="text-sm text-[#465362] mb-1">Services</h4>
                <p className="font-medium">{project?.services}</p>
              </div>
              <div>
                <h4 className="text-sm text-[#465362] mb-1">Completion</h4>
                <p className="font-medium">{project?.completion}</p>
              </div>
            </div>

              <div className="flex flex-wrap gap-2 mb-8">
                  {project?.tags
                      ?.split(",") // split by comma
                      .map(tag => tag.trim()) // remove extra spaces
                      .map((tag, i) => (
                          <span
                              key={i}
                              className="bg-blue-100 text-[#0258DA] text-xs font-medium px-3 py-1 rounded-full"
                          >
                              {tag}
                          </span>
                      ))}
              </div>


              <div className="flex justify-between items-center max-md:flex-col gap-4">
              {/*<div className="flex items-center">*/}
              {/*  <div className="w-10 h-10 rounded-full bg-[#0258DA] flex items-center justify-center text-white font-bold text-xs mr-2">*/}
              {/*    JD*/}
              {/*  </div>*/}
              {/*  <div className="w-10 h-10 rounded-full bg-blue-500 flex items-center justify-center text-white font-bold text-xs -ml-2">*/}
              {/*    MK*/}
              {/*  </div>*/}
              {/*  <div className="w-10 h-10 rounded-full bg-blue-400 flex items-center justify-center text-white font-bold text-xs -ml-2">*/}
              {/*    AL*/}
              {/*  </div>*/}
              {/*  <div className="w-10 h-10 rounded-full bg-gray-200 text-[#465362] flex items-center justify-center text-xs font-bold -ml-2">*/}
              {/*    +3*/}
              {/*  </div>*/}
              {/*</div>*/}
              <button
                onClick={handleOpenModal}
                className="btn-primary"
              >
                View Case Study
              </button>
            </div>
          </div>
        </div>
      </div>

      {/*<div className="grid grid-cols-1 md:grid-cols-3 gap-8 mt-12">*/}
      {/*  <div className="bg-white rounded-lg shadow-md p-6">*/}
      {/*    <div className="result-number">45%</div>*/}
      {/*    <div className="result-label">Increase in User Engagement</div>*/}
      {/*  </div>*/}

      {/*  <div className="bg-white rounded-lg shadow-md p-6">*/}
      {/*    <div className="result-number">32%</div>*/}
      {/*    <div className="result-label">Reduction in Bounce Rate</div>*/}
      {/*  </div>*/}

      {/*  <div className="bg-white rounded-lg shadow-md p-6">*/}
      {/*    <div className="result-number">58%</div>*/}
      {/*    <div className="result-label">Increase in Lead Generation</div>*/}
      {/*  </div>*/}
      {/*</div>*/}

      {/* Project Information Modal */}
      <ProjectInformationModal
        open={modalOpen}
        onClose={handleCloseModal}
        project={project}
      />
    </section>
  );
}
